module.exports = __webpack_public_path__ + "img/ultrasound.db7b5af4.jpeg";